import { create } from "zustand";
import { persist } from "zustand/middleware";

export type FontId =
  | "system"
  | "inter"
  | "merriweather"
  | "opendyslexic"
  | "fira-code"
  | "jetbrains-mono";

export type LanguageMode = "js" | "python";

export interface ThemeOption {
  id: string;
  label: string;
}

export interface FontOption {
  id: FontId;
  label: string;
}

export const THEME_OPTIONS: ThemeOption[] = [
  { id: "clean-light", label: "Clean Light" },
  { id: "clean-dark", label: "Clean Dark" },
  { id: "stanford-light", label: "Stanford Light" },
  { id: "stanford-dark", label: "Stanford Dark" },
];

export const FONT_OPTIONS: FontOption[] = [
  { id: "system", label: "System UI" },
  { id: "opendyslexic", label: "OpenDyslexic" },
  { id: "inter", label: "Inter" },
  { id: "merriweather", label: "Merriweather" },
  { id: "fira-code", label: "Fira Code" },
  { id: "jetbrains-mono", label: "JetBrains Mono" },
];

export const DEFAULT_THEME = "clean-light";
export const DEFAULT_FONT: FontId = "system";

export const FONT_CLASSES: Record<FontId, string> = {
  system: "",
  inter: "font-inter",
  merriweather: "font-merriweather",
  opendyslexic: "font-opendyslexic",
  "fira-code": "font-fira-code",
  "jetbrains-mono": "font-jetbrains-mono",
};

interface ThemeState {
  themeId: string;
  fontId: FontId;
  languageMode: LanguageMode;
  lintingEnabled: boolean;
  setThemeId(id: string): void;
  setFontId(id: FontId): void;
  setLanguageMode(mode: LanguageMode): void;
  setLintingEnabled(enabled: boolean): void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      themeId: DEFAULT_THEME,
      fontId: DEFAULT_FONT,
      languageMode: "python",
      lintingEnabled: true,

      setThemeId: (id) => set({ themeId: id }),
      setFontId: (id) => set({ fontId: id }),
      setLanguageMode: (mode) => set({ languageMode: mode }),
      setLintingEnabled: (enabled) => set({ lintingEnabled: enabled }),
    }),
    { name: "karel-preferences" },
  ),
);

export function isDarkTheme(themeId: string): boolean {
  return /-dark$/.test(themeId);
}
